module.exports = __webpack_public_path__ + "static/media/prop-2-thumb.84f9153c.webp";